<mat-toolbar class="header">
  @if (showBackLink) {
    @switch (behaviourType) {
      @case ('link') {
        <a class="cancel" [routerLink]="cancelUrl" mat-button color="primary">
          <rma-icon glyph="arrow_back" matButtonIcon />
          <span>{{ label ?? 'action.cancel' | transloco }}</span>
        </a>
      }
      @case ('button') {
        <button type="button" class="cancel" (click)="backClick.emit()" mat-button color="primary">
          <rma-icon glyph="arrow_back" matButtonIcon />
          <span>{{ label ?? 'action.cancel' | transloco }}</span>
        </button>
      }
    }
  }

  <div class="rma-logo-container">
    <a class="full-size" routerLink="/">
      <img alt="{{ 'dashboard.brand' | transloco }} Logo" [src]="lgRenownedLogoPath | staticImageUrl" />
    </a>
    <a class="mini-size" routerLink="/">
      <img alt="{{ 'dashboard.brand' | transloco }} Logo" [src]="smRenownedLogoPath | staticImageUrl" />
    </a>
  </div>
</mat-toolbar>
